import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { ListResponse, PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { AdvancedListRequest } from "types/api/commons";

import { ProductMaterialBody, ProductMaterialListItem } from "types/api/productMaterial";

function useProductMaterialApi() {
    const { get, del, post } = useHttpManaged();
    const getAllProductMaterial = React.useCallback((queryParams: AdvancedListRequest, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ListResponse<ProductMaterialListItem>> => {
        return get<undefined, AdvancedListRequest, ListResponse<ProductMaterialListItem>>({
            url: "/product-material",
            queryParams: queryParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const createProductMaterial = React.useCallback((body: ProductMaterialBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<undefined, undefined, ProductMaterialBody, ResponseWithId>({
            url: "/product-material",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const deleteProductMaterial = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/product-material/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getAllProductMaterial,
        createProductMaterial,
        deleteProductMaterial
    };
}

export default useProductMaterialApi;
